"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapWithLoader = void 0;

var _containers = require("./containers");

var removeLoader = function removeLoader() {
  var loaderContainer = document.getElementById("loaderContainer");
  loaderContainer.style.display = "none";
};

var wrapWithLoader = function wrapWithLoader(iframe) {
  var iframeContainer = (0, _containers.createIframeContainer)();
  iframeContainer.appendChild(iframe);
  iframe.onload = removeLoader;
  var wrapper = (0, _containers.createWrapper)();
  var loaderContainer = (0, _containers.createLoaderContainer)();
  wrapper.appendChild(loaderContainer);
  wrapper.appendChild(iframeContainer);
  return wrapper;
};

exports.wrapWithLoader = wrapWithLoader;